import slice, { addEvent, fetchCtsByCartId } from './events.slice';
export { addEvent, fetchCtsByCartId };
export default slice.reducer;
